// IMPORT
    // MODULE(S)
        import React from 'react';
    // STYLE(S)
        import '../sass/App.scss';
    // COMPONENT(S)
        import Header from './Header';
        import Main from './Main';
        import Footer from './Footer';



// MAIN CONTENT - FUNCTION / COMPONENT
    function App() {


        // RETURN
            return (
                <div className="App">
                    <Header />
                    <Main />
                    <Footer />
                </div>
            );
    }
    export default App;
